module.exports = __webpack_public_path__ + "img/chevron-right.1638b946.svg";